// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__3cTtT","Nav":"Header_Nav__1108A","Username":"Header_Username__DGRyR","RegionIcon":"Header_RegionIcon__29oQi","WorldIcon":"Header_WorldIcon__5dEDh"};